import "./index.scss";
import { CardContact } from "@wise-emotions/react-card";
import { FileItemProps } from "./types";
import React from "react";

const FileItem = ({ file, label, caption = "" }: FileItemProps) => {
  return (
    <div data-testid="file-item" className="file-item">
      <CardContact
        title={label}
        description={caption}
        variant="download"
        as="a"
        href={file.url}
        target="_blank"
        rel="noopener noreferrer"
      />
    </div>
  );
};

export default FileItem;
